import { Component, Prop, h } from '@stencil/core';

import actions from '../../../actions/actions.interactive-banner';
import XIcon from '../../ui-common/svg/XIcon';

@Component({
  tag: 'banner-next',
  styleUrl: './banner-next.css',
  shadow: true,
})
export class BannerNext {
  @Prop() url: string;
  @Prop() isOpen: boolean;
  @Prop() callback: Function = () => {};
  @Prop() showDesktop: boolean = false;
  @Prop() zIndex: number = 2000;

  onCloseClick = () => {
    this.unLockBodyScrolling();
    actions.onModalClose();
    actions.checkSessionStorageToContinue();
  };

  onBackDropClick = () => {
    this.onCloseClick();
    if (this.callback) {
      this.callback();
    }
  };
  onCloseButtonClick = () => {
    this.onCloseClick();
    if (this.callback) {
      this.callback();
    }
  };
  // See https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
  lockBodyScrolling() {
    const { scrollY } = window;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100vw';
    document.body.style.height = '100vh';
  }

  unLockBodyScrolling() {
    const scrollY = document.body.style.top; // keep const, stop setting as 'let' (the variable itself doesn't change and is const)

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.height = '';

    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
  renderOverlay() {
    if (this.isOpen) {
      this.lockBodyScrolling();
    } else {
      this.unLockBodyScrolling();
    }
    const closeButtonClass = {
      'w-8 h-8 z-20 -ml-4 -mt-4 absolute rounded-full': true,
      'text-clrs-kbb-borderblue text-center align-middle cursor-pointer border-0': true,
    };

    return (
      <div
        class="flex justify-center items-center w-full h-full fixed inset-0 overflow-y-auto bg-black/50"
        role="dialog"
        aria-modal="true"
        onClick={this.onBackDropClick}
        style={{ 'z-index': this.zIndex.toString() }}>
        <div class="text-right w-11/12 h-5/6">
          <button onClick={this.onCloseButtonClick} class={closeButtonClass}>
            <XIcon />
          </button>
        </div>
        <div class="w-11/12 h-5/6 absolute">
          <iframe class="border-none w-full h-full" src={this.url}></iframe>
        </div>
      </div>
    );
  }
  render() {
    return <div class={this.isOpen ? 'visible' : 'invisible'}>{this.renderOverlay()}</div>;
  }
}
